import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { AiFillGithub, AiOutlineMail } from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";
import './Contact.css';

function Contact() {
  return (
    <Container fluid className="contact-section" id="contact">
      <Container>
        <Row className="justify-content-center">
          <Col lg={8}>
            <div className="animate-fade-in-up">
              <h1 className="project-heading text-center mb-4">
                Let's <strong className="text-gradient">Connect</strong>
              </h1>
              <p className="contact-description text-center mb-5">
                I'm always interested in discussing cloud architecture, DevOps practices, 
                or how to modernize enterprise systems. Feel free to reach out!
              </p>
            </div>
            
            {/* Social Icons Only */}
            <div className="contact-social-links">
              <ul className="contact-social-list">
                <li className="social-icons">
                  <a
                    href="mailto:benjamin.c.szabo@gmail.com"
                    className="contact-social-icon"
                    title="Email"
                  >
                    <AiOutlineMail />
                  </a>
                </li>
                <li className="social-icons">
                  <a
                    href="https://linkedin.com/in/benjamin-szabo-b593bb190"
                    target="_blank"
                    rel="noreferrer"
                    className="contact-social-icon"
                    title="LinkedIn"
                  >
                    <FaLinkedinIn />
                  </a>
                </li>
                <li className="social-icons">
                  <a
                    href="https://github.com/benszabo"
                    target="_blank"
                    rel="noreferrer"
                    className="contact-social-icon"
                    title="GitHub"
                  >
                    <AiFillGithub />
                  </a>
                </li>
              </ul>
            </div>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Contact;